import React from 'react';
import Typography from "@mui/material/Typography";

const personnelData = [
  { branch: 'U.S. Army', personnel: 1600000 },
  { branch: 'U.S. Marine Corps', personnel: 391000 },
  { branch: 'U.S. Navy', personnel: 174000 },
  { branch: 'U.S. Air Force', personnel: 273000 },
  { branch: 'U.S. Coast Guard', personnel: 10000 },
];

export const personnelTable = (<>
  <Typography style={{paddingBottom: '16px'}}>About 2.6 million American personnel served in Vietnam throughout the duration of the conflict</Typography>
    <table style={{width: '100%'}}>
      <thead>
      <tr>
        <th style={{textAlign: 'start'}}>Military Branch</th>
        <th style={{textAlign: 'end'}}># Personnel</th>
      </tr>
      </thead>
      <tbody>
      {personnelData.map((data, index) => (
        <tr key={index}>
          <td style={{minWidth: '165px'}}>{data.branch}</td>
          <td style={{textAlign: 'end'}}>{data.personnel.toLocaleString()}</td>
        </tr>
      ))}
      </tbody>
    </table>
  </>);
